<template>
    <div>
        <ringer v-if="ringing" />
        <agora-client v-if="isConnected&&provider=='agora'" />
        <twilio-client  v-if="isConnected&&provider=='twilio'" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
const Ringer = () => import(/* webpackChunkName: "ringer" */ "./Ringer.vue");
const AgoraClient = () => import(/* webpackChunkName: "agoraclient" */ "./agora-client/AgoraClient.vue");
const TwilioClient = () => import(/* webpackChunkName: "twilio-client" */ "./twilio-client/TwilioClient.vue")
import  moment from 'moment';
export default {
    name:"VideoCall",
    data(){
        return{
            timer: "00 : 00",
            interval:null
        }
    },
    components: {
        Ringer,
        AgoraClient,
        TwilioClient,
    },
    computed: {
        ...mapGetters({
            ringing: 'ringing'
        }),
        isConnected() {
            const status = this.$store.getters.callStatus;
            return (status=='connected' || status == 'inprogress');
        },
        provider() {
            const payload = this.$store.getters.videocallPayload;
            return payload.provider || 'agora';
        },
        payloadUserDetails(){ 
            return JSON.parse(this.$localStorage.get("appDetails"))
        }
    },
    methods: {
         setTimer(){
            let _self = this
            _self.interval = setInterval(() => {
                console.log(_self.timer, 'initialTimer')
            _self.timer = moment(_self.timer, "mm : ss")
                .add(1, "seconds")
                .format("mm : ss");
            }, 1000);
        },
        clearTimer() {
            clearInterval(this.interval);
            setTimeout(() => {
                this.timer = "00 : 00"
            }, 500);
        }
    }
}
</script>